import Axios from 'axios';

const s3Instance = Axios.create();


function cleanPresignedUrl(rawUrl) {
    let url = rawUrl.trim();
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
    }
    const urlObj = new URL(url);
    return urlObj.href
        .replace('"https//', '')
        .replace('%22', '')
        .replace('https://s3.eu-west-1.amazonaws.com/', '/saos3/');
}

export class S3Service {

    getPresignedUploadUrl(fileName) {
        return Axios.get(`/s3/presigned-url/${fileName}?method=put`, { responseType: 'text' });
    }

    uploadFileToS3(presignedUrl, file) {
        const finalUrl = cleanPresignedUrl(presignedUrl);
        return s3Instance.put(finalUrl, file, {
            headers: { 'Content-Type': file.type },
            responseType: 'text',
        });
    }

    getPresignedDownloadUrl(fileName) {
        return Axios.get(`/s3/presigned-url/${fileName}?method=get`, { responseType: 'text' });
    }

    downloadFile(presignedUrl, fileName) {
        const finalUrl = cleanPresignedUrl(presignedUrl);
        return s3Instance.get(finalUrl, { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        });
    }

    setFile(saos3FileName, file) {
        return Axios.put(`/s3/test-object/${saos3FileName}`, file, {
            headers: { 'Content-Type': 'application/octet-stream' },
        });
    }

    getImage(imageName) {
        return Axios.get(`/s3/object/${imageName}`, {
            headers: {
                'Content-Type': 'application/octet-stream',
                'Accept': 'application/octet-stream',
            },
            responseType: 'blob',
        });
    }
}
